import Reflux from 'reflux';

let SearchActions = Reflux.createActions({
  clear: {},
  toggleVisibility: {},
  bindHotKeys: {},
  unbindHotKeys: {},
  search: {},
  setActiveResultIndex: {},
  addReplaceToResult: {},
  removeReplaceFromResult: {},
  replaceChecked: {},
  replaceAll: {},
  refreshList: {},
  setSearchFocusState: {},
  setReplaceFocusState: {},
  setReplaceAllClickState: {},
  setReplaceInputVal: {},
});

export default SearchActions;
